import {Pipe, PipeTransform} from '@angular/core';
import {AppointmentStatusEnum, AppointmentTypeEnum} from '../../models/appointment';
import {CalendarEvent} from 'angular-calendar';

@Pipe({
  name: 'filterAppointments'
})
export class FilterAppointmentsPipe implements PipeTransform {

  transform(value: CalendarEvent[], filter: AppointmentTypeEnum | AppointmentStatusEnum | 'ALL'): CalendarEvent[] {
    if (filter === 'ALL') {
      return value;
    }
    return value.filter(item => item.meta.status === filter || item.meta.type === filter);
  }

}
